import React from 'react';
import { store } from 'react-notifications-component';
import Notification, { TProps } from '../components/notification/notification';

export const showNotification = (props: TProps) => {
  store.addNotification({
    container: 'top-right',
    content: <Notification {...props} />,
    width: 340,
    dismiss: {
      duration: 4000,
      pauseOnHover: true,
    },
  });
};
